import { ServiceMaker, methods, services } from "@/services";

export const listTaxcode = id =>
  ServiceMaker(`/pricing/tax-codes/view`, methods.GET, services.master);

export const createTaxcode = payload =>
  ServiceMaker(
    `/pricing/tax-codes/create`,
    methods.PUT,
    services.master,
    payload
  );

export const updateTaxcode = payload =>
  ServiceMaker(
    `/pricing/tax-codes/edit`,
    methods.PATCH,
    services.master,
    payload
  );

export const deleteTaxcode = Id =>
  ServiceMaker(`/pricing/tax-codes/remove`, methods.DELETE, services.master, {
    _id: Id
  });
